(function () {
  function init(root) {
    if (root.dataset.elbInit) return;
    root.dataset.elbInit = '1';

    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-elb-config]').textContent); }
    catch (e) { console.warn('elb: bad config', e); return; }

    var minItems = cfg.minItems || 3;
    var moneyFmt = cfg.moneyFormat || '€{{amount}}';
    var labels   = cfg.labels || {};


    // setPrice / extraUnitPrice / fullUnitPrice come from theme settings in the
    // shop's BASE currency, so they must be converted to the active currency.
    // Real variant prices (data-price) are already converted by Shopify — don't touch those.
    (function convertConfigPrices() {
      var rate = elbCurrency().rate;
      if (rate === 1) return;
      ['setPrice', 'extraUnitPrice', 'fullUnitPrice'].forEach(function (k) {
        if (typeof cfg[k] === 'number') cfg[k] = Math.round(cfg[k] * rate);
      });
    })();

    var tiers      = root.querySelectorAll('[data-elb-tier]');
    var scentRows  = Array.prototype.slice.call(root.querySelectorAll('[data-elb-scent]'));
    var swatches   = Array.prototype.slice.call(root.querySelectorAll('[data-elb-swatch]'));
    var counterEl  = root.querySelector('[data-elb-counter]');
    var cartBtn    = root.querySelector('[data-elb-cart]');
    var cartPrice  = root.querySelector('[data-elb-cart-price]');
    var heroBottle = root.querySelector('[data-elb-hero-bottle]');
    var heroEl = root.querySelector('.elb__hero');
    var heroImg    = root.querySelector('[data-elb-hero-img]');
    var wheel      = root.querySelector('[data-elb-wheel]');
    var wheelItems = Array.prototype.slice.call(root.querySelectorAll('[data-elb-wheel-item]'));
    var scentTitle = root.querySelector('[data-elb-scent-title]');
    var singlePrice= root.querySelector('[data-elb-single-price]');
    var singlePer  = root.querySelector('[data-elb-single-per]');
    var setPriceEl = root.querySelector('[data-elb-set-price]');
    var setCompareEl = root.querySelector('[data-elb-set-compare]');
    var setPerEl = root.querySelector('[data-elb-set-per]');
    var ribbonEl = root.querySelector('[data-elb-ribbon]');
    var ribbonBase = ribbonEl ? ribbonEl.textContent : '';
    var singleCompare = root.querySelector('[data-elb-single-compare]');
    var boxPriceEl     = root.querySelector('[data-elb-box-price]');
    var boxCompareEl   = root.querySelector('[data-elb-box-compare]');
    var heroTrack = root.querySelector('[data-elb-hero-track]');
    var codeBadges = root.querySelectorAll('[data-elb-code-badge]');
    var heroStatic = root.querySelector('[data-elb-hero-static]');

    var selectedTier = root.dataset.defaultTier || 'single';
    var activeSwatch = root.querySelector('[data-elb-swatch].is-active') || swatches[0];

    /* ---------- money ---------- */
    /*function money(cents) {
      var amount = cents / 100;
      function fmt(num, dec) {
        var parts = num.toFixed(dec == null ? 2 : dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return parts[0] + (parts[1] ? ',' + parts[1] : '');
      }
      return moneyFmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
        return k.indexOf('no_decimals') !== -1 ? fmt(amount, 0) : fmt(amount, 2);
      });
    }*/
    function elbCurrency() {
      var c = (window.Shopify && window.Shopify.currency) || {};
      var code = c.active || cfg.shopCurrency || '';
      var rate = parseFloat(c.rate != null ? c.rate : '1') || 1;
      return { code: code, rate: rate };
    }

    function money(cents) {
      var amount = cents / 100; 
      var cur = elbCurrency();
      if (cur.code && window.Intl && Intl.NumberFormat) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'de', {
            style: 'currency',
            currency: cur.code
          }).format(amount);
        } catch (e) { /* fall through to legacy format */ }
      }
      function fmt(num, dec) {
        var parts = num.toFixed(dec == null ? 2 : dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return parts[0] + (parts[1] ? ',' + parts[1] : '');
      }
      return moneyFmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
        return k.indexOf('no_decimals') !== -1 ? fmt(amount, 0) : fmt(amount, 2);
      });
    }

    /* ---------- set helpers ---------- */
    function qtyOf(r) { return parseInt(r.querySelector('[data-elb-qty]').textContent, 10) || 0; }
    function setQty(r, v) { r.querySelector('[data-elb-qty]').textContent = v; }
    function totalSet() { return scentRows.reduce(function (a, r) { return a + qtyOf(r); }, 0); }

    function paintRow(r) {
      var on = qtyOf(r) > 0;
      r.classList.toggle('is-on', on);
      var c = r.dataset.color || '#5bb84a';
      r.style.background = on ? c : '';
    }
// 3× set total with per-mist Detora discount applied to each mist's bundle share
    /*function bundleTotalDisc(total) {
      if (total <= 0) return 0;
      var groupTotal = bundleTotal(total);
      var unit = groupTotal / total;          // each mist's share of the bundle price
      var sum = 0;
      scentRows.forEach(function (r) {
        var q = qtyOf(r);
        if (q > 0) sum += applyDisc(parseInt(r.dataset.variantId, 10), unit) * q;
      });
      return Math.round(sum);
    }*/
   /*function bundleTotalDisc(total) {
      var eff = Math.max(total, minItems);
      if (eff <= 0) return 0;
      var unit = bundleTotal(eff) / eff; 
      var sum = 0, counted = 0;
     
      scentRows.forEach(function (r) {
        var q = qtyOf(r);
        if (q > 0) { sum += applyDisc(parseInt(r.dataset.variantId, 10), unit) * q; counted += q; }
      });
      
      var remaining = eff - counted;
      if (remaining > 0) {
        var av = activeSwatch ? parseInt(activeSwatch.dataset.variantId, 10) : 0;
        sum += applyDisc(av, unit) * remaining;
      }
      return Math.round(sum);
    }*/
    function bundleTotalDisc(total) {
      var eff = Math.max(total, minItems);
      if (eff <= 0) return 0;
      var base = bundleTotal(eff);
      if (!discActive || !parentDisc) return base;
      // Fixed-amount discount (calc:"amt") -> subtract the flat amount.
      if (parentDisc.calc === 'amt') {
        return Math.max(0, base - Math.round((parentDisc.discAmt || 0) * 100));
      }
      // Percentage discount -> scale the total.
      return Math.round(base * (1 - (parentDisc.discPerc || 0) / 100));
    }
    // Bundle group total
    function bundleTotal(total) {
      if (total <= 0) return 0;
      if (total <= minItems) return cfg.setPrice; 
      return cfg.setPrice + (total - minItems) * (cfg.extraUnitPrice || 0);
    }
    function bundleCompare(total) {
      return (cfg.fullUnitPrice || 0) * total;
    }

    function refreshSteppers() {
      var total = totalSet();
      var atCap = total >= minItems;
      /*scentRows.forEach(function (r) {
        r.querySelector('[data-elb-step="-1"]').disabled = qtyOf(r) === 0;
        r.querySelector('[data-elb-step="1"]').disabled = atCap; 
      });*/
      scentRows.forEach(function (r) {
        var q = qtyOf(r);
        r.querySelector('[data-elb-step="-1"]').disabled = q === 0;
        r.querySelector('[data-elb-step="1"]').disabled = atCap;
        r.classList.toggle('is-locked', atCap && q === 0); 
      });
      if (counterEl) {
        var done = total >= minItems;
        counterEl.firstChild.textContent = (done ? total : total + ' / ' + minItems) + ' ';
        counterEl.classList.toggle('is-full', done);
      }
      
      var normalSet = bundleTotal(Math.max(total, minItems));
      var discSet   = bundleTotalDisc(Math.max(total, minItems));
      if (setPriceEl) setPriceEl.textContent = money(discSet);
      if (setPerEl) setPerEl.textContent = money(Math.round(discSet / Math.max(total, minItems)));
      /*if (setCompareEl) {
        if (discSet < normalSet) {
          setCompareEl.textContent = money(normalSet);
          setCompareEl.hidden = false;
        } else {
          setCompareEl.textContent = money(bundleCompare(Math.max(total, minItems)));
          setCompareEl.hidden = false;
        }
      }*/
      if (setCompareEl) {
        // Always show the real compare-at (full unit price × qty).
        // Do NOT switch to the lower set price when a discount code is applied.
        setCompareEl.textContent = money(bundleCompare(Math.max(total, minItems)));
        setCompareEl.hidden = false;
      }
      if (ribbonEl) {
        if (discActive && discSet < normalSet) {
          var saved = Math.round((bundleCompare(Math.max(total, minItems)) - discSet) / 100);
          var alt = ribbonEl.getAttribute('data-elb-ribbon-alt') || ribbonBase;
          ribbonEl.textContent = alt.indexOf('{save}') >= 0 ? alt.replace('{save}', saved) : alt;
        } else {
          ribbonEl.textContent = ribbonBase;
        }
      }
    }
    function refreshBox() {
      var boxEl = root.querySelector('[data-elb-tier="box"]');
      if (!boxEl) return;
      var vId = parseInt(boxEl.dataset.variantId, 10);
      var raw = parseInt(boxEl.dataset.price, 10) || 0;
      if (!raw) return;
      var disc = applyDisc(vId, raw);
      if (boxPriceEl) boxPriceEl.textContent = money(disc);
      if (boxCompareEl) {
        if (disc < raw) { boxCompareEl.textContent = money(raw); boxCompareEl.hidden = false; }
        else { boxCompareEl.hidden = true; }
      }
    }
    /* ---------- button ---------- */
    function refreshButton() {
      if (selectedTier === 'bundle') {
        var total = totalSet();
        /*if (total < minItems) {
          cartBtn.classList.add('is-incomplete');
          cartBtn.firstChild.textContent =
            (labels.incomplete || 'Choose %n more').replace('%n', minItems - total) + '\u00a0';
          if (cartPrice) cartPrice.textContent = '';
          return;
        }*/
      if (total < minItems) {
        cartBtn.classList.add('is-incomplete');
        var remaining = minItems - total;
        var tmpl = (remaining === 1 && labels.incompleteSingular)
          ? labels.incompleteSingular
          : (labels.incomplete || 'Choose %n more');
        cartBtn.firstChild.textContent = tmpl.replace('%n', remaining) + '\u00a0';
        if (cartPrice) cartPrice.textContent = '';
        return;
      }
        cartBtn.classList.remove('is-incomplete');
        setPrice(bundleTotalDisc(total));
      } else if (selectedTier === 'single') {
        setPrice(applyDisc(parseInt(activeSwatch.dataset.variantId, 10), parseInt(activeSwatch.dataset.price, 10) || 0));
      } else if (selectedTier === 'box') {
        var box = root.querySelector('[data-elb-tier="box"]');
        setPrice(applyDisc(parseInt(box.dataset.variantId, 10), parseInt(box.dataset.price, 10) || 0));
      }
    }
    function setPrice(cents) {
      cartBtn.disabled = false;
      cartBtn.classList.remove('is-incomplete');
      cartBtn.firstChild.textContent = (labels.cart || 'Add to cart') + '\u00a0 | \u00a0';
      if (cartPrice) cartPrice.textContent = money(cents);
    }
    function parsePrice(t) {
      var n = t.replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
      return Math.round(parseFloat(n) * 100) || 0;
    }

    /* ---------- url sync ---------- */
    function updateUrl() {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('tier', selectedTier);
        if (selectedTier === 'single' && activeSwatch && activeSwatch.dataset.name) {
          url.searchParams.set('scent', activeSwatch.dataset.name.toLowerCase());
        } else {
          url.searchParams.delete('scent');
        }
        // replaceState = no back-button buildup. Swap to pushState if you want history steps.
        window.history.replaceState(null, '', url);
      } catch (e) { /* theme editor / sandboxed iframe */ }
    }

    /* ---------- tier select ---------- */
    function selectTier(name) {
      selectedTier = name;
      updateUrl();
      tiers.forEach(function (t) { t.classList.toggle('is-selected', t.dataset.elbTier === name); });
      refreshButton();

      // 3× and 5× show a single static hero image (no wheel); 1× restores the wheel
      if (heroEl) {
        if (name === 'bundle' || name === 'box') {
          var bg = (name === 'bundle') ? heroEl.dataset.bundleBg : heroEl.dataset.boxBg;
          if (heroStatic && bg) heroStatic.style.backgroundImage = "url('" + bg + "')";
          heroEl.classList.add('elb__hero--static');
        } else {
          heroEl.classList.remove('elb__hero--static');
        }
      }

      // keep the just-selected tier in view after its expand — only the expandable tiers
      if (name === 'bundle' || name === 'box') {
        var sel = root.querySelector('[data-elb-tier="' + name + '"]');
        if (sel) {
          setTimeout(function () {
            sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 480);
        }
      }
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.target.closest('.elb__stepper')) return;
        selectTier(t.dataset.elbTier);
      });
    });

    /* ---------- steppers ---------- */
    scentRows.forEach(function (r) {
      paintRow(r);
      r.querySelectorAll('[data-elb-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.dataset.elbStep, 10);
          var cur = qtyOf(r);
          if (dir < 0 && cur === 0) return;
          if (dir > 0 && totalSet() >= minItems) return;
          setQty(r, cur + dir);
          paintRow(r);
          if (selectedTier !== 'bundle') selectTier('bundle');
          refreshSteppers();
          refreshButton();
        });
      });
    });

    /* ---------- swatch -> 1× tier + hero bottle ---------- */
    function applySwatch(sw) {
      activeSwatch = sw;
      swatches.forEach(function (s) { s.classList.remove('is-active'); });
      sw.classList.add('is-active');
      
      var color = sw.dataset.color || 'var(--elb-magenta)';
      root.style.setProperty('--elb-accent', color);

      var vId = parseInt(sw.dataset.variantId, 10);
      var raw = parseInt(sw.dataset.price, 10) || 0;
      var cmp = parseInt(sw.dataset.compare, 10) || 0;
      var disc = applyDisc(vId, raw);
      if (singlePrice) singlePrice.textContent = money(disc);
      if (singlePer)   singlePer.textContent = money(disc);
      if (singleCompare) {
        var strike = Math.max(cmp, raw); // native UVP wins; falls back to pre-discount price
        if (strike > disc) { singleCompare.textContent = money(strike); singleCompare.hidden = false; }
        else { singleCompare.hidden = true; }
      }

      if (scentTitle) scentTitle.innerHTML = ` ${sw.dataset.name || ''} <span>${sw.dataset.notes || ''}</span> `;

      var idx = swatches.indexOf(sw);
      if (idx < 0) idx = 0;
      positionWheel(idx);

      if (heroTrack) {
        heroTrack.style.transform = 'translateX(' + (-idx * 100) + '%)';
      }

      // keep the URL's scent param in sync while on the single tier
      if (selectedTier === 'single') { updateUrl(); refreshButton(); }
    }

    /* ---------- rotary wheel ---------- */
    var wheelAngle = 0; 
    function positionWheel(active) {
      var n = wheelItems.length;
      if (!n || !wheel) return;
      var step = 360 / n;
      var target = -active * step;
      
      var current = ((wheelAngle % 360) + 360) % 360;
      var t = ((target % 360) + 360) % 360;
      var diff = t - current;
      if (diff > 180) diff -= 360;
      if (diff < -180) diff += 360;
      wheelAngle += diff;
      wheel.style.transform = 'rotate(' + wheelAngle + 'deg)';
      wheelItems.forEach(function (item, i) {
        item.classList.toggle('is-center', i === active);
        
        var net = ((((wheelAngle + i * step) % 360) + 360) % 360);
        if (net > 180) net -= 360;
        var visible = Math.abs(net) <= step + 1;
        item.style.opacity = visible ? '1' : '0';
        item.style.pointerEvents = visible ? '' : 'none';
      });
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () { applySwatch(sw); selectTier('single'); });
    });

    /* ---------- add to cart ---------- */
    cartBtn.addEventListener('click', function () {
      if (cartBtn.classList.contains('is-incomplete')) {
        selectTier('bundle');
        var bundleTier = root.querySelector('[data-elb-tier="bundle"]');
        if (bundleTier) {
          setTimeout(function () {
            bundleTier.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 480);
        }
        return;
      }
      if (cartBtn.disabled) return;
      var items = [];

      if (selectedTier === 'bundle') {
        var total = totalSet();
        var groupTotal = bundleTotal(total);
        var uniqueId = Date.now().toString();
        var parentId = root.dataset.parentVariant || '';
        scentRows.forEach(function (r) {
          var q = qtyOf(r);
          if (q > 0) {
            var props = {
              _uniqueId: uniqueId,
              _bundleDiscount: (groupTotal / 100).toFixed(2),
              _size: total
            };
            if (parentId) props._parentId = parentId;
            items.push({ id: parseInt(r.dataset.variantId, 10), quantity: q, properties: props });
          }
        });
      } else if (selectedTier === 'single') {
        items.push({ id: parseInt(activeSwatch.dataset.variantId, 10), quantity: 1 });
      } else if (selectedTier === 'box') {
        var box = root.querySelector('[data-elb-tier="box"]');
        items.push({ id: parseInt(box.dataset.variantId, 10), quantity: 1 });
      }
      if (items.length) submitCart(items);
    });

    function submitCart(items) {
      cartBtn.classList.add('is-loading');
      var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      // --- Cart drawer wiring ---
      
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',
        { bubbles: true, detail: { sections: sections } }));

      fetch(routes + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: sections.join(',') })
      })
        .then(function (res) { return res.json(); })
        .then(function (responseJson) {
          
          return fetch(routes + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = responseJson.sections;
            
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cart }
            }));
            toast(labels.added || 'Added to cart');
          });
        })
        .catch(function (err) { console.error('elb cart error', err); toast('Etwas ist schiefgelaufen.'); })
        .finally(function () { cartBtn.classList.remove('is-loading'); });
    }

    /* ---------- toast ---------- */
    var toastEl;
    function toast(msg) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.style.cssText = 'position:fixed;left:50%;bottom:26px;transform:translateX(-50%) translateY(20px);' +
          'background:#262321;color:#fff;padding:13px 22px;border-radius:30px;font-size:13px;z-index:9999;' +
          'opacity:0;transition:.3s;font-family:Inter,sans-serif;pointer-events:none;';
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      requestAnimationFrame(function () {
        toastEl.style.opacity = '1'; toastEl.style.transform = 'translateX(-50%) translateY(0)';
      });
      clearTimeout(toast._t);
      toast._t = setTimeout(function () {
        toastEl.style.opacity = '0'; toastEl.style.transform = 'translateX(-50%) translateY(20px)';
      }, 2600);
    }
    /* ---------- Detora discount  ---------- */
    var discPct = {};  
    var discActive = false;
    var parentDisc = null;
    /* for speed
    function waitForCo2(cb, n) {
      n = n || 0;
      if (typeof co2 !== 'undefined') cb();
      else if (n < 30) setTimeout(function () { waitForCo2(cb, n + 1); }, 200);
    }
    */
   function waitForCo2(cb, n) {
      n = n || 0;
      if (typeof co2 !== 'undefined') cb();
      else if (n < 120) setTimeout(function () { waitForCo2(cb, n + 1); }, 50);
    }
    // discounted cents for a given variant (falls back to original if no discount)
    function applyDisc(variantId, cents) {
      if (discActive && discPct[variantId] > 0) {
        return Math.round(cents * (1 - discPct[variantId] / 100));
      }
      return cents;
    }

    /*function loadDiscounts() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (!(cart.discount_codes && cart.discount_codes.length)) {
          if (co2.getDiscountCode) { Promise.resolve(co2.getDiscountCode()).then(function (c) { if (c) co2.removeDiscountCode(); }); }
          return; 
        }
        var code = cart.discount_codes[0].code || cart.discount_codes[0];
        return Promise.resolve(co2.setDiscountCode(code)).then(function () {
          // gather every priced element: swatches (1x), scent rows (set), box
          var els = swatches.concat(scentRows);
          var boxEl = root.querySelector('[data-elb-tier="box"]');
          if (boxEl) els.push(boxEl);
          var jobs = els.map(function (el) {
            var pid = parseInt(el.dataset.productId, 10);
            var vid = parseInt(el.dataset.variantId, 10);
            var price = parseInt(el.dataset.price, 10);
            var tags = (el.dataset.tags || '').split(',').filter(Boolean);
            if (!pid || !vid || !price) return Promise.resolve();
            return Promise.resolve(co2.itemDiscountFull(pid, vid, tags, price, 1)).then(function (res) {
              if (res && res.discPrice > 0 && res.discPrice < price) {
                discActive = true;
                discPct[vid] = res.discPerc;
              }
            }).catch(function () {});
          });
          return Promise.all(jobs);
        }).then(function () {
          // re-render everything with discounts applied
          /*if (activeSwatch) applySwatch(activeSwatch);
          refreshSteppers();
          refreshButton();
          // re-render everything with discounts applied
          if (activeSwatch) applySwatch(activeSwatch);
          refreshSteppers();
          refreshButton();
          codeBadges.forEach(function (b) {
            if (discActive) { b.textContent = 'Code: ' + code; b.hidden = false; }
            else { b.hidden = true; }
          });
        });
      }).catch(function () {});
      if (activeSwatch) applySwatch(activeSwatch);
          refreshSteppers();
          refreshButton();
          refreshBox();
    }*/
    function loadDiscounts() {
      cartPromise.then(function (cart) {
        if (!(cart.discount_codes && cart.discount_codes.length)) {
          if (co2.getDiscountCode) { Promise.resolve(co2.getDiscountCode()).then(function (c) { if (c) co2.removeDiscountCode(); }); }
          return;
        }
        var code = cart.discount_codes[0].code || cart.discount_codes[0];
        return Promise.resolve(co2.setDiscountCode(code)).then(function () {
          // gather every priced element: swatches (1x), scent rows (set), box
          var els = swatches.concat(scentRows);
          var boxEl = root.querySelector('[data-elb-tier="box"]');
          if (boxEl) els.push(boxEl);
          var jobs = els.map(function (el) {
            var pid = parseInt(el.dataset.productId, 10);
            var vid = parseInt(el.dataset.variantId, 10);
            var price = parseInt(el.dataset.price, 10);
            var tags = (el.dataset.tags || '').split(',').filter(Boolean);
            if (!pid || !vid || !price) return Promise.resolve();
            return Promise.resolve(co2.itemDiscountFull(pid, vid, tags, price, 1)).then(function (res) {
              if (res && res.discPrice > 0 && res.discPrice < price) {
                discActive = true;
                discPct[vid] = res.discPerc;
              }
            }).catch(function () {});
          });
          /*new for discount*/
          // The bundle discount lives on the PARENT product. Its Shopify price is 0
          // (the bundle app assembles the price from children), so fall back to the
          // configured set price. Keep the FULL result so we can handle both
          // percentage and fixed-amount ("amt") discounts.
          var pPid   = parseInt(root.dataset.parentProduct, 10);
          var pVid   = parseInt(root.dataset.parentVariant, 10);
          var pPrice = parseInt(root.dataset.parentPrice, 10) || cfg.setPrice;
          var pTags  = (root.dataset.parentTags || '').split(',').filter(Boolean);
          if (pPid && pVid && pPrice) {
            jobs.push(Promise.resolve(co2.itemDiscountFull(pPid, pVid, pTags, pPrice, 1)).then(function (res) {
              if (res && res.discPrice > 0 && res.discPrice < pPrice) {
                discActive = true;
                parentDisc = res;
              }
            }).catch(function () {}));
          }
          return Promise.all(jobs);
        }).then(function () {
          // re-render everything with discounts applied
          if (activeSwatch) applySwatch(activeSwatch);
          refreshSteppers();
          refreshButton();
          refreshBox();
          codeBadges.forEach(function (b) {
            var t = b.querySelector('[data-elb-code-text]');
            if (discActive) {
              if (t) t.textContent = code;  
              b.hidden = false;
            } else {
              b.hidden = true;
            }
          });

          var ribbon = root.querySelector('[data-elb-ribbon]');
          if (ribbon) {
            var altText = ribbon.dataset.elbRibbonAlt;
            if (discActive && altText) {
              if (!ribbon.dataset.elbRibbonOriginal) {
                ribbon.dataset.elbRibbonOriginal = ribbon.textContent.trim();
              }
              ribbon.textContent = altText;
            } else if (ribbon.dataset.elbRibbonOriginal) {
              ribbon.textContent = ribbon.dataset.elbRibbonOriginal;
            }
          }

          root.classList.toggle('elb--has-code', discActive);
        });
      }).catch(function () {});
    }
    /* ---------- sticky ATC when scrolled out of view ---------- */
    (function stickyCart() {
     
      var spacer = document.createElement('div');
      cartBtn.parentNode.insertBefore(spacer, cartBtn.nextSibling);

      function setSpacer() { spacer.style.height = cartBtn.classList.contains('is-stuck') ? cartBtn.offsetHeight + 'px' : '0px'; }

      var sentinel = document.createElement('div'); 
      cartBtn.parentNode.insertBefore(sentinel, cartBtn);

      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        
        var stick = !e.isIntersecting && e.boundingClientRect.top < 0;
        cartBtn.classList.toggle('is-stuck', stick);
        setSpacer();
      }, { threshold: 0 });

      io.observe(sentinel);
    })();

/* ---------- Pfeil-Klick: nach oben scrollen ---------- */
cartBtn.addEventListener('click', function (e) {
  // nur reagieren, wenn der Klick im Bereich des Pfeils (oberhalb des Buttons) war
  var rect = cartBtn.getBoundingClientRect();
  if (cartBtn.classList.contains('is-stuck') && e.clientY < rect.top + 4) {
    e.stopPropagation();
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}, true);

    /* ---------- boot ---------- */
    (function readUrlState() {
      var params = new URLSearchParams(window.location.search);
      var urlTier = params.get('tier');
      if (urlTier && root.querySelector('[data-elb-tier="' + urlTier + '"]')) {
        selectedTier = urlTier;
      }
      var urlScent = params.get('scent');
      if (urlScent) {
        var match = swatches.filter(function (s) {
          return (s.dataset.name || '').toLowerCase() === urlScent.toLowerCase();
        })[0];
        if (match) activeSwatch = match;
      }
    })();

    positionWheel(activeSwatch ? swatches.indexOf(activeSwatch) : 0);
    if (activeSwatch) applySwatch(activeSwatch);
    selectTier(selectedTier);
    refreshSteppers();
    refreshBox();  
    refreshButton();
    var cartPromise = fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return {}; });
    waitForCo2(loadDiscounts);

    /* ---------- preload all swatch hero backgrounds ---------- */
    swatches.forEach(function (sw) {
      if (sw.dataset.hero) {
        var img = new Image();
        img.src = sw.dataset.hero;
      }
    });
    // preload the 3× and 5× static hero images
    [heroEl.dataset.bundleBg, heroEl.dataset.boxBg].forEach(function (src) {
      if (src) { var img = new Image(); img.src = src; }
    });
    /* ---------- swipe the wheel (mobile only) ---------- 
    (function enableWheelSwipe() {
      if (!wheel) return;
      var startX = 0, startY = 0, tracking = false, locked = false, horizontal = false;
      function isMobile() { return window.matchMedia('(max-width:767px)').matches; }

      wheel.addEventListener('touchstart', function (e) {
        if (!isMobile()) return;
        var t = e.touches[0];
        startX = t.clientX; startY = t.clientY;
        tracking = true; locked = false; horizontal = false;
      }, { passive: true });

      wheel.addEventListener('touchmove', function (e) {
        if (!tracking) return;
        var t = e.touches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        if (!locked) {
          
          if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
            locked = true;
            horizontal = Math.abs(dx) > Math.abs(dy);
          }
        }
        
        if (locked && horizontal) e.preventDefault();
      }, { passive: false });

      wheel.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        if (!horizontal) return;   
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        if (Math.abs(dx) < 40) return; 
        var n = swatches.length;
        if (!n) return;
        var cur = swatches.indexOf(activeSwatch);
        if (cur < 0) cur = 0;
        var next = dx < 0 ? (cur + 1) % n : (cur - 1 + n) % n;
        applySwatch(swatches[next]);
        selectTier('single');
      }, { passive: false });
    })();*/
    /* ---------- swipe the hero (mobile only) ---------- */
    (function enableWheelSwipe() {
      if (!heroEl) return;
      var startX = 0, startY = 0, tracking = false, locked = false, horizontal = false;
      function isMobile() { return window.matchMedia('(max-width:767px)').matches; }
      
      function wheelVisible() { return !heroEl.classList.contains('elb__hero--static'); }

      heroEl.addEventListener('touchstart', function (e) {
        if (!isMobile() || !wheelVisible()) return;
        var t = e.touches[0];
        startX = t.clientX; startY = t.clientY;
        tracking = true; locked = false; horizontal = false;
      }, { passive: true });

      heroEl.addEventListener('touchmove', function (e) {
        if (!tracking) return;
        var t = e.touches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        if (!locked) {
          if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
            locked = true;
            horizontal = Math.abs(dx) > Math.abs(dy);
          }
        }
        if (locked && horizontal) e.preventDefault();
      }, { passive: false });

      heroEl.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        if (!horizontal) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        if (Math.abs(dx) < 40) return;
        var n = swatches.length;
        if (!n) return;
        var cur = swatches.indexOf(activeSwatch);
        if (cur < 0) cur = 0;
        var next = dx < 0 ? (cur + 1) % n : (cur - 1 + n) % n;
        applySwatch(swatches[next]);
        selectTier('single');
      }, { passive: false });
    })();
  }

  function boot() { document.querySelectorAll('.elb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();